export default __webpack_public_path__ + "static/media/Logo.73af491d.png";